import React from "react";
import {debug} from "../utils";
import {connect} from "react-redux";
// import { FILE_API } from "../vars";
// import noImageLogo from '../auth/user_logo.png';

export function UserMenu({firstName, lastName, logoUrl, ticket}) {

    if (!ticket) {
        return null;
    }

    // Calculate initials
    const initials = `${firstName ? firstName.charAt(0) : ''}${lastName ? lastName.charAt(0) : ''}`.toUpperCase() || 'AA';

    return (
        <div className="user-profile">
            <div className="avatar">
                <div className="avatar-initials">
                    {initials}
                </div>
            </div>
            <span className="user-name">{firstName} {lastName}</span>
        </div>
    );
}

function mapStateToProps(state) {
    debug("UserMenu mapStateToProps", state);
    return {
        firstName: state.auth.firstName,
        lastName: state.auth.lastName,
        logoUrl: state.auth.logoUrl,
        ticket: state.auth.access_token
    };
}

export default connect(mapStateToProps)(UserMenu);
